module.exports = __webpack_public_path__ + "media/app/img/promo8-b3e021e305856ec173499953cad6605e.png";